import { formatToTimeZone } from "date-fns-timezone"

import getLocalTimezone from "./getLocalTimezone"

export default function(date, config = { timeZone: getLocalTimezone(), specifyTimezoneAtEnd: true }) {
  const { timeZone = getLocalTimezone(), specifyTimezoneAtEnd = true } = config
  return formatToTimeZone(date, `YYYY-MM-DD HH:mm:ss${specifyTimezoneAtEnd ? " z" : ""}`, {timeZone})
}
